import React, {Component} from 'react';
import { inject, observer } from 'mobx-react';
import SubHeader from './SubHeader';

import './RouteTaskDashboard.css';
import RouteTaskTable from './RouteTaskTable'

@inject('routeTaskStore', 'commonStore', 'translationsStore', 'driversStore')
@observer
export default class RouteTaskDashboard extends Component {
  constructor(props) {
    super(props);

    this.state = {};
    const { routeTaskStore } = this.props;
    routeTaskStore.load();
  }

  componentDidMount() {
    this.props.driversStore.load();
  }

  componentWillUnmount = () => {
    this.props.routeTaskStore.resetFilters();
  };

  render() {
    const { routeTaskStore } = this.props;
    return (
      <div className={`routeTasksDashboard ${this.props.commonStore.loading ? 'loading' : ''}`}>
        <SubHeader />
        {this.props.commonStore.loading === false && <RouteTaskTable routes={routeTaskStore.routeTasks} routeTasksTotal={routeTaskStore.routeTasksTotal}/>}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/RouteTaskDashboard/RouteTaskDashboard.js